import { apiUrl } from 'app/config'
import { getHeaderJwtJson, getOnlyJwt } from "helpers/FetchHelper";
import { IUserProfile } from 'entities/UserProfile';

const urlUser = apiUrl + "users/";
const base64Prfix = "data:image/*;base64,";

let defaultUserProfile = {} as IUserProfile;

export const getUserData = async (idUser: string): Promise<IUserProfile> => {
  const responce = await fetch(urlUser + idUser,
    {
      method: "GET",
      headers: getHeaderJwtJson()
    });
  let data = await responce.json();
  return responce.ok ? data : defaultUserProfile;
};

export const saveUserData = async (userProfile: IUserProfile, saveT: string, errorT: string) => {
  const responce = await fetch(urlUser + userProfile.id + "/updateProfile", {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(userProfile)
  });

  if (responce.ok === true)
    return true;
  alert(errorT);
  return false;
};

export const setAvatar = async (idUser: string, file: string, changeAvatar: (img: string) => void) => {
  const formData = new FormData();
  formData.append("Base64File", file);
  const responce = await fetch(urlUser + idUser + "/updateAvatar", {
    method: "POST",
    headers: getOnlyJwt(),
    body: formData
  });

  if (responce.ok !== true)
    console.log("Error load Image");
  else
    changeAvatar(file);

  return responce.ok;
};

export const getAvatar = async (idUser: string) => {
  const responce = await fetch(urlUser + idUser + "/getAvatar", {
    method: "GET",
    headers: getHeaderJwtJson()
  });
  if (responce.ok === true) {
    let data = await responce.json();
    return data;
  }
  return undefined;
};

export const getAvatars = async (ids: string[]) => {
  const responce = await fetch(urlUser + "getAvatars", {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(ids)
  });
  if (responce.ok === true) {
    let data = await responce.json();
    return data;
  }
  return undefined;
}

export const getCorrectFormatAvatars = async (ids: string[]) => {
  let avatars = await getAvatars(ids);
  if (!avatars)
    return undefined
  avatars.forEach((avatar: any) => {
    avatar.avatar = base64Prfix + avatar.avatar;
  });
  return avatars;
};

export const getCorrectFormatAvatar = async (idUser: string) => {
  let imgBase64 = await getAvatar(idUser);
  return imgBase64 ? base64Prfix + imgBase64 : "";
};

export const getProfileData = async (idUser: string, imgBase64: string): Promise<IUserProfile> => {
  let userProfile = await getUserData(idUser);
  userProfile.imgBase64 = imgBase64;
  return userProfile;
};
